import CommonStyles from './FJAiToolsItemCommon.module.less';
import Styles from './FJZoomInPreview.module.less';
import FJLocalStore from '../../../../../../store/FJLocalStore';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import FJImage from '../../../../../../common/components/FJImage/FJImage';
import FJUtil from '../../../../../../util/FJUtil';

const FJZoomInPreview = props => {
    const { name, url, jumpLink } = props;

    const _onClick = () => {
        if (jumpLink) window.open(jumpLink, '_blank');
        FJUtil.eaLog('ai home ai tool page click', {
            toolName: name.replaceAll('-', ' '),
        });
    };

    return (
        <div className={CommonStyles.itemBox}>
            <div className={classNames(CommonStyles.previewBox, Styles.imageBox)} onClick={_onClick}>
                <FJImage imgSrc={url} alt='' reloadStyle={{ backgroundColor: '#FFF', zIndex: 3 }} />
            </div>
            <div className={CommonStyles.itemName}>{FJLocalStore._(name)}</div>
        </div>
    );
};

FJZoomInPreview.propTypes = {
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    jumpLink: PropTypes.string.isRequired,
};

export default FJZoomInPreview;
